import * as customerActions from "./customerActions";
export default function customerReducer(state, action) {
  switch (action.type) {
    case customerActions.customerActions.CREATE_PAYMENT_NONCE:
      return {
        ...state,
        paymentNonce: action.payload,
      };
    default:
      return state;
  }
}
